import React from 'react';
import { Box, Input } from '@opendoor/bricks/core';
import { IResetableFormRenderProps } from 'sellDirect/components/closingDash/ResetableForm';
import { CustomInputLabel } from 'sellDirect/components/closingDash/form/CustomInputLabel';

const DCO_ID = 'dco-phonenumber';

interface PhoneNumberProps {
  resetableForm: IResetableFormRenderProps;
}

/**
 * Label and input for phone number.
 *
 * storybook-check-ignore
 */
export const PhoneNumber: React.FC<PhoneNumberProps> = ({
  resetableForm: { onUpdate, formState },
}) => (
  <Box mt={4}>
    <CustomInputLabel
      id={DCO_ID}
      title="Verify phone number"
      required={true}
      titleFontSize="s3"
      titleFontWeight="bold"
      mb={3}
    />
    <Input
      analyticsName="cake-closing-dash-phone-number"
      required
      type="tel"
      id={`${DCO_ID}-input`}
      data-testid="dco-phonenumber"
      name="phoneNumber"
      aria-labelledby={DCO_ID}
      value={formState?.phoneNumber}
      onChange={(_event, value) => {
        onUpdate('phoneNumber', value);
      }}
      unboundedWidth
      autoComplete="tel"
    />
  </Box>
);
